
import Breadcrumb from '@/components/Breadcrumb'
import defaultSettings from '@/settings'
import { mapGetters } from 'vuex'
import { setHistoryList } from '@/utils/validate'
import GOODS_TYPE from '@/enum'

export default {
	components: {
		Breadcrumb
	},
	props: {
		ClassName: {
			default: ''
		}
	},
	data() {
		return {
			defaultSettings,
			loading: true,
			firstChar: null, // 字母筛选
			gameCatalogueId: null, // 游戏类型
			typeIndex: null, // 商品类型
			gameData: null, //游戏列表
			historyData: [],
			gameCate: [
				{
					label: '全部游戏',
					value: null
				},
				{
					label: '端游',
					value: 1
				},
				{
					label: '手游',
					value: 2
				}
			],
			alphabet: [],
			showBack: null,
			topHeader: null,
			search: '',
			gameCateListForAllText: [{ id: null, name: '全部游戏' }]
		}
	},
	head() {
		if (!this.$config.isPublicProd) return {}
		return {
			title: '游戏账号交易平台_手游网游买号卖号平台-盼之代售',
			meta: [
				{
					hid: 'description',
					name: 'description',
					content: '盼之代售，专业正规的游戏账号交易平台，提供网游交易售卖，手游账号买号卖号服务。王者荣耀账号出售，穿越火线cf卖号交易，英雄联盟lol买号交易，原神账号交易充值等。'
				},
				{
					hid: 'keywords',
					name: 'keywords',
					content: '游戏账号交易，买游戏账号，卖游戏账号，盼之代售'
				}
			],
			script: [
				{
					hid: 'ldjson-schema',
					innerHTML: `{"@context": "https://ziyuan.baidu.com/contexts/cambrian.jsonid","@id":"https://${this.BAIDU_URL}","pubDate": "2023-03-20T18:11:13","upDate": "${this.BAIDU_DATE}"}`,
					type: 'application/ld+json'
				}
			],
			__dangerouslyDisableSanitizersByTagID: {
				'ldjson-schema': ['innerHTML']
			}
		}
	},
	// watch: {
	//   $route: {
	//     handler: function (route) {
	//       // 解决取不到值的bug
	//       setTimeout(() => {
	//         this.topHeader = parseInt(route.query.topHeader);
	//         if (!this.topHeader) return;
	//         this.gameData = [];
	//         this.action.goodsCatalogueId = this.topHeader;
	//         this.getHistoryList(this.action.goodsCatalogueId);
	//         this.getGameList(this.action);
	//       }, 100);
	//     },
	//     immediate: true,
	//   },
	// },
	computed: {
		...mapGetters({
			gameCateList: 'game/gameCateList',
			goodsTypeCateList: 'game/goodsTypeCateList',
			gameList: 'game/gameList',
			buyGoodsType: 'game/buyGoodsType'
		}),
		// gameCateListForAllText() {
		//   return [{ id: null, name: "全部游戏" }, ...this.gameCateList];
		// },
		gameListByFilter() {
			this.loading = true

			if (this.gameData) {
				this.loading = false
				return this.gameData.filter(item => {
					return item.name.indexOf(this.search) !== -1
				})
			} else if (this.gameList) {
				this.loading = false
				return this.gameList.filter(item => {
					return item.name.indexOf(this.search) !== -1
				})
			}
		}
		// gameListData(){
		//   return this.gameData || this.gameList;
		// }
	},
	async asyncData({ route, app }) {
		return {
			BAIDU_URL: process.env.BAIDU_URL + route.path,
			BAIDU_DATE: app.$formattedDateTime()
		}
	},
	async fetch({ store }) {
		// await store.dispatch('game/GoodsTypeCateList')
		// await store.dispatch('game/GameCateList')
		// await store.dispatch('game/GameList')
	},
	methods: {
		gotoPage(item) {
			let history = {
				goodsCatalogueId: this.typeIndex,
				...item
			}
			setHistoryList(history)
			this.$store.commit('game/SET_BUY_GOODS_TYPE', this.typeIndex)
			// this.$router.push({
			//   name: "goodsList",
			//   params: {
			//     gameId: item.id,
			//     gameName: item.gameName,
			//     goodsCatalogueId: this.typeIndex,
			//   },
			// });
		},
		getGoodsType(item) {
			this.typeIndex = item.id
			this.$store.commit('game/SET_BUY_GOODS_TYPE', this.typeIndex)
			this.$store.dispatch('game/GameList')
			this.getHistoryList(item.id)
			this.getGameList()
		},
		// 游戏类型栏目
		getGameDataByValue(value) {
			this.gameCatalogueId = value

			this.getGameList()
		},
		// 通过首字母获取游戏列表
		onClickAlphabet(val) {
			if (val === '全部') {
				this.firstChar = null
			} else {
				this.firstChar = val
			}
			this.getGameList()
		},
		getGameList() {
			this.loading = true
			const data = {
				action: {
					firstChar: this.firstChar,
					gameCatalogueId: this.gameCatalogueId,
					goodsCatalogueId: this.typeIndex
				}
			}
			this.$api.gameAll(data).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.loading = false
				console.log(res.data, '这是啥数据~~~')
				this.gameData = res.data
			})
		},
		getHistoryList(goodsCatalogueId) {
			// 解决nuxt 找不到windows的问题
			if (process.client) {
				let historyData = JSON.parse(window.localStorage.getItem('HistoryList')) || []
				if (!historyData.length) return
				this.historyData = historyData.filter(item => item.goodsCatalogueId === this.typeIndex || GOODS_TYPE.ACCOUNT)
				// let historyData = JSON.parse(window.localStorage.getItem('HistoryList')) || [];
				// let _arr = [];
				// if (!historyData.length) return;
				// historyData.map(item => {
				// 	this.gameList.map(element => {
				// 		if (item.id === element.id) {
				// 			_arr.push(item);
				// 		}
				// 	});
				// });
				// this.historyData = _arr.filter((item) => item.goodsCatalogueId === this.typeIndex || GOODS_TYPE.ACCOUNT)
			}
		}
	},
	created() {
		// 返回按钮
		this.showBack = this.$route.query.from
	},
	async mounted() {
		for (let i = 0; i < 26; i++) {
			this.alphabet.push(String.fromCharCode(65 + i))
		}
		this.alphabet.unshift('全部')

		this.typeIndex = this.buyGoodsType || (this.goodsTypeCateList[0] && this.goodsTypeCateList[0].id)
		this.getHistoryList()
		// this.gameData = this.gameList;
		this.gameCateListForAllText = this.gameCateListForAllText.concat([...this.gameCateList])
	}
}
